export const AUTH_RETURN_PATH_KEY = "authReturnPath";
